import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    graphOptions : [
        { name: 'Pie Chart', code: 'PC' },
        { name: 'Line Chart', code: 'LC' },
        { name: 'Radar Chart', code: 'RC' },
        { name: 'Stacked Bar Chart', code: 'SBC' },
        { name: 'Vertical Bar Chart', code: 'VBC' },
        { name: 'Multiaxis Line Chart', code: 'MLC' },
        { name: 'Bar Graph', code: 'BG' },
        { name: 'Bubble Chart', code: 'BC' },
    ],
    defaultGraphOptionOne : null,
    datasetsDefaultOne:[
        {
          labels:[
            {text:'Hospitality',color:'#BF1C1E'},
            {text:'Energy & Utilities',color:'#E59223'},
            {text:'Finance',color:'#03799D'},
            {text:'Technology',color:'#016E6E'},
            {text:'Healthcare',color:'#5E649F'},
          ],
          data: [13, 5, 8, 17, 5],
          backgroundColor: [
            "#BF1C1E",
            "#E59223",
            "#03799D",
            "#016E6E",
            "#5E649F",
          ],
          borderColor:'#000'
        },
      ],
    defaultGraphOptionTwo : null,
    datasetsDefaultTwo:[
        {
          labels:[
            {text:'Data Collection',color:'#188A88'},
            {text:'Translations',color:'#797FB9'},
            {text:'Full Service',color:'#EFCA4C'},
            {text:'Survey Programming',color:'#C43334'},
          ],
          data: [12, 19, 3, 5],
          backgroundColor: 
          ["#188A88", 
          "#797FB9", 
          "#EFCA4C", 
          "#C43334"],
          borderColor: [
            "#fff",
          ],
          borderWidth: 3,
        },
      ],
    defaultGraphOptionThree : null,
    datasetsDefaultThree:[{
        id: 1,
        data: [1, 9, 7, 5, 11, 13, 6, 5],
        borderColor: "#63A064",
        backgroundColor: "#63A064",
      },
      {
        id: 2,
        data: [7, 9, 3, 1, 2, 5, 7, 8],
    
        borderColor: "#797FB9",
        backgroundColor: "#797FB9",
      },
      {
        id: 3,
        data: [10, 23, 21, 25, 7, 5, 9, 11],
    
        borderColor: "#DD5D37",
        backgroundColor: "#DD5D37",
      },],
    defaultGraphOptionFour : null,
    datasetsDefaultFour:null,
    selectedGraphOne: null,
    selectedGraphTwo: null,
    selectedGraphThree: null,
    selectedGraphFour: null,
}

export const sliceName = 'graphSection'

export const GraphSectionSlice = createSlice({
    name:sliceName,
    initialState,
    reducers:{
        onGraphSelectOne : (state,action) => {
            state.selectedGraphOne = action.payload
        },
        onGraphSelectTwo : (state,action) => {
            state.selectedGraphTwo = action.payload
        },
        onGraphSelectThree : (state,action) => {
            state.selectedGraphThree = action.payload
        },
        onGraphSelectFour : (state,action) => {
            state.selectedGraphFour = action.payload
        },
        setDefaultGraphOne : (state,action) => {
            state.defaultGraphOptionOne = action.payload
        },
        setDefaultGraphTwo : (state,action) => {
            state.defaultGraphOptionTwo = action.payload
        },
        setDefaultGraphThree : (state,action) => {
            state.defaultGraphOptionThree = action.payload
        },
        setDefaultGraphFour : (state,action) => {
            state.defaultGraphOptionFour = action.payload
        },
        changeDatasetsDefaultOne: (state,action) => {
          state.datasetsDefaultOne = [...state.datasetsDefaultOne,state.datasetsDefaultOne[0].data = action.payload]
        }
    }
})

export const { onGraphSelectOne,setDefaultGraphFour,
  setDefaultGraphOne,setDefaultGraphThree,setDefaultGraphTwo,
  onGraphSelectFour,onGraphSelectThree,onGraphSelectTwo,changeDatasetsDefaultOne } = GraphSectionSlice.actions

export const selectAllGraphData = state => state[sliceName]

export default GraphSectionSlice.reducer